// import api from './fetchApi'
import chain from '@/lib/axios-chain'

// 获取左侧菜单

// 获取组织和项目默认列表数据
export const orgIndex = () => chain.create('/user/organize/index', 'get')

// 创建组织
export const createOrgItem = () =>
  chain.create('/user/organize/createorg', 'post')
// 修改组织名称
export const editOrgName = () =>
  chain.create('/user/organize/modifyorgname', 'post')
// 转让组织第一步
export const tranfOrgFirst = () =>
  chain.create('/user/organize/transfercheck', 'post')
// 转让组织第二步
export const tranfOrgSecond = () =>
  chain.create('/user/organize/transferorg', 'post')
// 配置
// 获取提交配置数据
export const getCollectDatas = () => chain.create('/config/gettype', 'get')

// 获取地区数据
export const getAreaDatas = () => chain.create('/config/area/country', 'get')

// 提交信息配置数据
export const subCollectDatas = () => chain.create('/config/submitadd', 'post')

// 提交来源信息配置
export const subReferrerDatas = () => chain.create('/config/fromadd', 'post')

// 提交来源信息配置
export const subVisitDatas = () => chain.create('/config/followadd', 'post')

// 获取通知设置数据
export const getNoticeDatas = () => chain.create('/config/getnotice', 'get')

// 获取插入变量数据
export const getVarDatas = () => chain.create('/config/getallow', 'get')

// 编辑通知信息提交
export const subEditNotice = () => chain.create('/config/upnotice', 'post')

// 获取邮件和短信数据
export const getEmailSmsDatas = () =>
  chain.create('/config/getwarningnum', 'get')
// 设置邮件和短信数据
export const setEmailSmsDatas = () =>
  chain.create('/config/setwarningnum', 'post')
// 通知设置开关
export const noticeSwitchOpen = () =>
  chain.create('/config/switchnotice', 'post')

// 获取关联概览数据
export const getRelateDatas = () =>
  chain.create('/config/getconfigrelate', 'get')

// 获取关联概览数据
export const getRelateDevpDatas = () =>
  chain.create('/user/team/getauthusersinfobypkandauth', 'get')

// 获取关联概览数据
export const getRelateOrigionDatas = () => chain.create('/config/getallfromconfig', 'get')
// 提交关联配置
export const subrelationDatas = () => chain.create('/config/relateadd', 'post')

// 获取敏感字段数据
export const getSensitiveDatas = () => chain.create('/config/getsensitiveinfo', 'get')
// 设置敏感字段
export const setSensitiveFields = () => chain.create('/config/upallsensitiveinfo', 'post')
// 获取信息查重字段
export const getRepeatFields = () => chain.create('/config/getcheckrepeat', 'get')
// 设置查重字段
export const setRepeatFields = () => chain.create('/config/upcheckrepeat', 'post')
// 获取信息查重开发
export const getRepeatSwitch = () => chain.create('/config/getcheckrepeatswitch', 'get')
// 设置信息查重开关
export const setRepeatSwitchInfo = () => chain.create('/config/upcheckrepeatswitch', 'post')
// 获取查重白名单
export const getRepeatWhiteList = () => chain.create('/config/getwhitelist', 'get')
// 设置查重白名单
export const setRepeatWhiteList = () => chain.create('/config/setwhitelist', 'post')

// 设置信息查重开关
export const getOperaLogs = () => chain.create('/config/getconfiglog', 'get')
// 获取服务升级价格
export const getServiceCountPrice = () => chain.create('/config/getcountprice', 'post')
// 服务升级支付
export const servicePay = () => chain.create('/config/pay', 'post')
// 服务升级关系判断
export const serviceInfo = () => chain.create('/config/getpayrelateproinfo', 'get')
// 获取短信余量
export const getSmsLave = () => chain.create('/config/getonsale', 'get')
// 项目logo上传初始化
export const getLogoInfo = () => chain.create('/user/project/prodetail', 'get')
// 上传项目logo
export const uploadLogo = () => chain.create('/upload/signature', 'post')
// 设置logo
export const setLogo = () => chain.create('/user/project/setlogo', 'post')
// 获取ocpc
export const getOcpc = () => chain.create('/config/getConfigOcpc', 'get')
// 设置ocpc
export const setOcpc = () => chain.create('/config/setConfigOcpc', 'post')
// 获取万能表单配置
export const getSmartConfig = () => chain.create('/config/getconfigformc', 'get')
// 设置万能表单配置
export const setSmartCOnfig = () => chain.create('/config/setconfigformc', 'posts')
// 删除万能表单配置中的单个IP
export const delSmartIP = () => chain.create('/config/delconfigformcip', 'post')
// 获取设置规则依据
export const getAllocationDatas = () => chain.create('/config/getAssignUseField', 'get')

// 设置分配规则依据
export const setAllocationForm = () => chain.create('/config/updateConfigFieldById', 'post')

// 获取分配规则列表数据
export const getAllocationListDatas = () => chain.create('/config/getAssignConfig', 'get')
// 添加或者编辑分配规则
export const editAllocation = () => chain.create('/config/setAssignConfig', 'post')

// 删除分配规则
export const delAllocation = () => chain.create('/config/delAssignConfig', 'post')

// 获取设置列表的角色列表
export const getlistRolesDatas = () => chain.create('/inquiry/config/getlistrole', 'get')
// 获取设置列表的菜单
export const getlistmenuDatas = () => chain.create('/inquiry/config/getlistmenu', 'get')
// 获取设置列表的设置字段
export const getlistfieldsDatas = () => chain.create('/inquiry/config/getlist', 'get')

// 获取设置列表的设置字段
export const setFieldsDatas = () => chain.create('/inquiry/config/setlist', 'post')

// 获取设置列表的设置字段
export const editMethod = () => chain.create('/user/team/setgroupassignway', 'post')
// 申请服务升级高级版体验
export const vipJoin = () => chain.create('/config/usevip', 'post')
// 创建导入任务
export const bulkImportAdd = () => chain.create('/inquiry/bulkimport/add', 'post')

// 获取导入列表
export const getImportLists = () => chain.create('/inquiry/bulkimport/lists', 'get')

// 删除导入任务
export const DelBulkImport = () => chain.create('/inquiry/bulkimport/delete', 'post')

// 获取表头
export const getImportTableHeader = () => chain.create('/inquiry/bulkimport/getTableHeader', 'get')

// 获取列的聚合结果
export const getImportAggregation = () => chain.create('/inquiry/bulkimport/getAggregation', 'get')

// 验证列格式
export const getImportValidFormat = () => chain.create('/inquiry/bulkimport/validFormat', 'get')

// 获取可选对应字段
export const bulkImportGetFields = () => chain.create('/inquiry/import/getfields', 'get')

// 设置字段对应关系
export const bulkImportSetFields = () => chain.create('/inquiry/import/setfields', 'post')

// 下载模板
/* export const getBulkImportTemplate = () => chain.create('/inquiry/import/template', 'get') */

export const getBulkImportTemplateUrl = () => chain.create('/inquiry/import/geturl', 'get')

// 导出出错的excel
export const bulkImportDownError = () => chain.create('/inquiry/bulkimport/exportError', 'get')

// 获取webhook列表
export const getWebhookList = () => chain.create('/config/webhook/getHookList', 'get')

// 获取webhook列表
export const getWebhookRecordList = () => chain.create('/config/webhook/getHookRecordList', 'get')

// 获取webhook详情
export const getWebhookDetail = () => chain.create('/config/webhook/getHookById', 'get')

// 获删除webhook
export const DelWebhook = () => chain.create('/config/webhook/del', 'post')

// 获取推送记录详情
export const getWebhookRecordDetail = () => chain.create('/config/webhook/getHookRecordById', 'get')

// 再次推送
export const sendRecordAgain = () => chain.create('/config/webhook/reHook', 'post')

// 再次推送
export const addEditWebhook = () => chain.create('/config/webhook/save', 'post')

// 初始化json数据
export const getInitJsonData = () => chain.create('/config/webhook/getInitJsonData', 'get')

// 初始化json数据 获取插入json变量
export const getVarData = () => chain.create('/config/webhook/getFieldByType', 'get')

// 测试推送json
export const validForm = () => chain.create('/config/webhook/hook', 'post')
// 测试推送json
export const setStopUsing = () => chain.create('/config/webhook/set', 'post')

// 开启共享
export const openShare = () => chain.create('/user/project/openShare', 'post')

// 关闭共享
export const closeShare = () => chain.create('/user/project/closeShare', 'post')

// ocpc推送记录
export const getOcpcRecordListDatas = () => chain.create('/config/getOcpcList', 'get')

// ocpc推送统计
export const getOcpcstatistiData = () => chain.create('/config/getOcpcStatisti', 'get')

// ocpc设置列表
export const getOcpcSetListDatas = () => chain.create('/config/getOcpcSetting', 'get')

// 开启ocpc
export const openOcpc = () => chain.create('/config/openOcpc', 'get')

// 关闭ocpc
export const closeOcpc = () => chain.create('/config/closeOcpc', 'get')

// ocpc:yandex申请授权clientid重复验证
export const yandexClientidCheck = () => chain.create('/config/verifyClientId', 'get')

// 线索配置获取配置数据
export const fetchClueCofigData = () => chain.create('/inquiry/clue/getClueConfig', 'get')
// 提交线索配置数据
export const subClueCofigData = () => chain.create('/inquiry/clue/setClueConfig', 'post')

// 线索配置获取配置字段
export const fetchClueCofigFieldsData = () => chain.create('/inquiry/inquiry/getconfig', 'get')

// 线索配置关闭或者开启
export const setClueOpenClose = () => chain.create('/inquiry/clue/upIsopen', 'post')

// 关联项目，添加关联
export const addRelativePro = () => chain.create('/config/addProjectRelate', 'post')

// 获取关联项目
export const fetchRelativeProData = () => chain.create('/config/getRelateInfo', 'get')
// 解除关联项目
export const relieveRelativePro = () => chain.create('/config/delProjectRelate', 'post')
